module.exports = __webpack_public_path__ + "img/logonew.81c8c301.png";